<template>
  <div>
    <b-row>
      <!-- Left Section: Tables and Chart -->
      <b-col cols="12" md="8">
        <b-row>
          <b-col
              v-if="$permissionAbility(TASK_DASHBOARD_TODAY_DEADLINE, permissions)"
              cols="12"
              md="6"
              class="mb-3"
          >
            <TodayAssignedTable :key="viewAs" :is-subtask="showSubtasks" :viewAs="viewAs" />
          </b-col>

          <b-col
              v-if="$permissionAbility(TASK_DASHBOARD_WEEK_DEADLINE, permissions)"
              cols="12"
              md="6"
              class="mb-3"
          >
            <WeeklyDueTasks :key="viewAs" :is-subtask="showSubtasks" :viewAs="viewAs" />
          </b-col>
        </b-row>

        <b-row>
          <b-col
              v-if="$permissionAbility(TASK_DASHBOARD_BY_PHASE, permissions)"
              :cols="viewAs !== 'employee' ? 6 : 12"
              class="mb-3"
          >
            <TaskByPhaseChart :key="viewAs" :is-subtask="showSubtasks" :viewAs="viewAs" />
          </b-col>

          <b-col
              v-if="$permissionAbility(TASK_DASHBOARD_BY_ASSIGNEE, permissions) && viewAs !== 'employee'"
              :cols="$permissionAbility(TASK_DASHBOARD_BY_PHASE, permissions) ? 6 : 12"
              class="mb-3"
          >
            <TaskByAssigneeChart :key="viewAs" :is-subtask="showSubtasks" :viewAs="viewAs" />
          </b-col>
        </b-row>

      </b-col>

      <!-- Right Section: Stats, Buttons, Logs -->
      <b-col cols="12" md="4">

        <b-button-group class="w-100 d-flex justify-content-between mb-3">
          <b-button
              :variant="viewAs === 'employee' ? 'primary' : 'outline-primary'"
              @click="viewAs = 'employee'"
          >
            My Task
          </b-button>
          <b-button
              :variant="viewAs === 'supervisor' ? 'primary' : 'outline-primary'"
              @click="viewAs = 'supervisor'"
          >
            Supervisor
          </b-button>
          <b-button
              v-if="$permissionAbility(TASK_DASHBOARD_VIEW_AS_ADMIN, permissions)"
              :variant="viewAs === 'admin' ? 'primary' : 'outline-primary'"
              @click="viewAs = 'admin'"
          >
            Admin
          </b-button>
        </b-button-group>

        <b-button-group class="w-100 d-flex justify-content-between mb-3">
          <b-button
              :variant="!showSubtasks ? 'primary' : 'outline-primary'"
              @click="showSubtasks = false"
          >
            Tasks
          </b-button>
          <b-button
              :variant="showSubtasks ? 'primary' : 'outline-primary'"
              @click="showSubtasks = true"
          >
            Subtasks
          </b-button>
        </b-button-group>

        <div class="mb-3">
          <DashboardStatisticsView
              v-if="$permissionAbility(TASK_DASHBOARD_STATISTICS, permissions)"
              :key="viewAs"
              :is-subtask="showSubtasks"
              :viewAs="viewAs"
          />
        </div>

        <div>
          <DashboardActivityLog
              v-if="$permissionAbility(TASK_DASHBOARD_ACTIVITY_LOG, permissions)"
              :members="allMemberIdOptions"
              :is-subtask="showSubtasks"
              :viewAs="viewAs"
              :key="viewAs"
          />
        </div>
      </b-col>
    </b-row>
  </div>
</template>


<script>
import {
  BAvatar,
  BBadge,
  BButton,
  BButtonGroup,
  BButtonToolbar,
  BCard,
  BCardBody,
  BCardHeader,
  BCardText,
  BCardTitle,
  BCol,
  BDropdown,
  BDropdownItem,
  BForm,
  BFormCheckbox,
  BFormDatepicker,
  BFormGroup,
  BFormInput,
  BFormRadio,
  BFormSelect,
  BLink,
  BListGroup,
  BListGroupItem,
  BModal,
  BPagination,
  BRow,
  BSpinner, BTab, BTabs,
  VBTooltip,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import Ripple from 'vue-ripple-directive'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { mapGetters } from 'vuex'

import LvColorPicker from 'lightvue/color-picker'
import { milestoneTaskBoardStatusConstants } from '@/helpers/constant/milestoneTaskBoardStatusConstant.js'
import BCardActions from '@core/components/b-card-actions/BCardActions.vue'
import flatPickr from 'vue-flatpickr-component'
import {
  milestoneBoardTypeConstants as milestoneBoardTypeConstant,
} from '@/helpers/constant/milestoneBoardTypeConstant.js'
import UserSelect from '@/layouts/components/UserSelect.vue'
import UserCard from '@/layouts/components/UserCard.vue'
import { formatDateRange } from '@/helpers/helpers'
import {
  required, max, size, ext, max_value, min_value,
} from '@validations'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import BCardCode from '@core/components/b-card-code'
import DashboardActivityLog from '@/views/admin/task-management/Dashboard/Component/DashboardActivityLog.vue'
import TodayAssignedTable from '@/views/admin/task-management/Dashboard/Component/TodayAssignedTable.vue'
import WeeklyDueTasks from '@/views/admin/task-management/Dashboard/Component/WeeklyDueTasksTable.vue'
import DashboardStatisticsView from '@/views/admin/task-management/Dashboard/Component/DashboardStatisticsView.vue'
import TaskByAssigneeChart from '@/views/admin/task-management/Dashboard/Component/TaskByAssigneeChart.vue'
import {
  TASK_DASHBOARD_ACCESS,
  TASK_DASHBOARD_ACTIVITY_LOG,
  TASK_DASHBOARD_STATISTICS,
  TASK_DASHBOARD_TODAY_DEADLINE,
  TASK_DASHBOARD_WEEK_DEADLINE,
  TASK_DASHBOARD_BY_ASSIGNEE,
  TASK_DASHBOARD_BY_PHASE,
  TASK_DASHBOARD_VIEW_AS_ADMIN,
} from "@/helpers/permissionsConstant";
import TaskByPhaseChart from '@/views/admin/task-management/Dashboard/Component/TaskByPhaseChart.vue'

export default {
  name: 'MilestoneTaskBoardListView',
  components: {
    TaskByPhaseChart,
    TaskByAssigneeChart,
    Chart,
    DashboardStatisticsView,
    WeeklyDueTasks,
    TodayAssignedTable,
    DashboardActivityLog,
    BTabs,
    BCardCode,
    BTab,
    AppTimeline,
    AppTimelineItem,
    UserCard,
    UserSelect,
    LvColorPicker,
    BForm,
    BRow,
    BCol,
    BButton,
    BButtonGroup,
    BButtonToolbar,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardText,
    BCardBody,
    BBadge,
    VueGoodTable,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    ValidationProvider,
    ValidationObserver,
    BModal,
    BSpinner,
    BLink,
    BListGroup,
    BListGroupItem,
    BFormDatepicker,
    BFormRadio,
    BFormCheckbox,
    flatPickr,
    BCardActions,
  },
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  computed: {
    ...mapGetters({
      permissions: "userModule/getPermissions",
    }),
  },
  data() {
    return {
      TASK_DASHBOARD_ACCESS,
      TASK_DASHBOARD_ACTIVITY_LOG,
      TASK_DASHBOARD_STATISTICS,
      TASK_DASHBOARD_TODAY_DEADLINE,
      TASK_DASHBOARD_WEEK_DEADLINE,
      TASK_DASHBOARD_BY_ASSIGNEE,
      TASK_DASHBOARD_VIEW_AS_ADMIN,
      TASK_DASHBOARD_BY_PHASE,

      allMemberIdOptions: [],
      statistics: [],
      showSubtasks: false,

      viewAs: 'employee',

    }
  },

  async created() {
    try {
      await this.loadItems();
    } catch (error) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Error',
          icon: 'BellIcon',
          variant: 'danger',
          text: error?.response?.data?.message,
        },
      })
    }
  },

  methods: {



    async loadItems() {
      try {
        // get all members
        const allMembers = await this.getAllMembers();

        this.allMemberIdOptions = allMembers?.data?.data?.map((item) => {
          return {
            avatar: item?.avatar,
            name: item?.name,
            email: item?.email,
            mobile: item?.mobile,
            employee_number: item?.employee_number,
            id: item?.id,
            departmentId: item?.department_id,
            inactive: !item?.status,
          };
        });

        const statistics = await this.$api.get(
            "api/tasks-dashboard/statistics"
        );

        this.statistics = statistics?.data

      } catch (error) {
        const message =
            error?.response?.data?.message ||
            error.message ||
            'Failed to load members';

        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Warning",
            icon: "BellIcon",
            variant: "warning",
            text: message,
          },
        });
      }
    },
    async getAllMembers() {
      return await this.$api.get(`api/users/all`);
    },
  },
}
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/pages/ui-feather.scss";

.table-custom-style {
  font-size: 13px !important;
  white-space: nowrap !important;
  min-height: 140px !important;
  tr,
  th,
  td {
    //vertical-align: middle !important;
    text-align: left !important;
  }
}
.table-cell-margin {
  margin: 8px 0px;
}
.second-layer-margin {
  margin-top: 15px;
}

.required-label label::after {
  content: " *";
  color: red;
}
</style>
